/**
 * Small formatting rules shared by the staff and member dashboards.
 * Pure functions, no React.
 */

export function greetingFor(date = new Date()) {
  const hour = date.getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

/** Whole naira with separators; keeps kobo only when there are some. */
export function formatNaira(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "\u20a60";
  const hasKobo = Math.round(n * 100) % 100 !== 0;
  return `\u20a6${n.toLocaleString("en-NG", {
    minimumFractionDigits: hasKobo ? 2 : 0,
    maximumFractionDigits: 2,
  })}`;
}

/** "2026-10-10" as a local date (a plain `new Date("2026-10-10")` is UTC and can shift a day). */
export function parseDateOnly(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ""));
  if (!match) return null;
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

/** Whole calendar days from `from` to `to` (negative when `to` is earlier). */
export function daysBetween(from, to) {
  const a = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  const b = new Date(to.getFullYear(), to.getMonth(), to.getDate());
  return Math.round((b - a) / 86400000);
}
